import { render, staticRenderFns } from "./DatasetAudioAnnotation.vue?vue&type=template&id=213fbc52&scoped=true&"
import script from "./DatasetAudioAnnotation.vue?vue&type=script&lang=js&"
export * from "./DatasetAudioAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./DatasetAudioAnnotation.vue?vue&type=style&index=0&id=213fbc52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fbc52",
  null
  
)

export default component.exports